import React, { useState, useEffect } from "react";
import classes from "../../assets/styles/Stats.module.css";
import nfcscannedIcon from "../../assets/images/function_page_icons/nfcscanned.svg";
import qrcodescanned from "../../assets/images/function_page_icons/qrcodescanned.svg";
import qr from "../../assets/images/function_page_icons/qr.svg";
import { useAtom } from "jotai";
import { loggedInUser, teamIDCheck } from "../../utils/store";
import { get } from "../../server";
import Loader from "../../components/Loader";
import showToast from "../../helpers/showToast";
import { TEAM_STATS } from "../../utils/constants/apiUrl";
import StatsDetail from "./StatsDetail";
import { Card } from "react-bootstrap";
import nfc from "../../assets/images/function_page_icons/nfc.svg";
import qrscan from "../../assets/images/function_page_icons/qrscan.svg";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement, // ✅ Import this
} from "chart.js";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement // ✅ Register this
);
const Stats = () => {
  const [loggedUser] = useAtom(loggedInUser);
  const [userTeamId] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(false);
  const [statsData, setStatsData] = useState({});
  const [isNFCStatsActive, setIsNFCStatsActive] = useState(true);
  const [isQRCodeStatsActive, setIsQRCodeStatsActive] = useState(false);
  const [isFunctionsStatsActive, setIsFunctionsStatsActive] = useState(false);

  const handleNFCStats = () => {
    setIsQRCodeStatsActive(false);
    setIsFunctionsStatsActive(false);

    setIsNFCStatsActive(!isNFCStatsActive);
  };
  const handleQRCodeStats = () => {
    setIsNFCStatsActive(false);
    setIsFunctionsStatsActive(false);
    setIsQRCodeStatsActive(!isQRCodeStatsActive);
  };
  const handleFunctionsStats = () => {
    setIsNFCStatsActive(false);
    setIsQRCodeStatsActive(false);
    setIsFunctionsStatsActive(!isFunctionsStatsActive);
  };

  const getStats = async () => {
    setLoading(true);

    let { status, message, data } = await get(
      `${TEAM_STATS}/${userTeamId || null}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setStatsData(data);
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  useEffect(() => {
    getStats();
  }, []);

  const data = {
    labels: ["NFC Stat", "Team QR Scan", "QR Scan"],
    datasets: [
      {
        data: [
          statsData?.totalTeamNfcStatCount || 0,
          statsData?.totalTeamQRStatCount || 0,
          statsData?.totalFunctionQRStatCount || 0,
        ],
        borderColor: "#09A0FF", // Optional: different colors
        backgroundColor: "#E8F6FF", // Optional: different border colors
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // 👈 This disables the legend
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="heading">
        <h1>Stats</h1>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-12 col-md-3">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="analyticsCardImg">
                  <img src={nfc} alt="NFC" />
                </div>
                <div>
                  <Card.Title>{statsData?.totalTeamNfcStatCount}</Card.Title>
                  <p>NFC Stat</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-12 col-md-3">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="analyticsCardImg">
                  <img src={qrscan} alt="NFC" />
                </div>
                <div>
                  <Card.Title>{statsData?.totalTeamQRStatCount}</Card.Title>
                  <p>QR Code Scan</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-12 col-md-3">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="analyticsCardImg">
                  <img src={qrscan} alt="NFC" />
                </div>
                <div>
                  <Card.Title>{statsData?.totalFunctionQRStatCount}</Card.Title>
                  <p>QR Code Scan</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-12 col-md-6">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <Bar data={data} options={options} />
            </Card.Body>
          </Card>
        </div>
      </div>

      {/* <div className="boxWrapper d-block">
        <div className="d-flex align-items-center gap-2 mainWrapper">
          <div
            className="statsBoxWrapper"
            onClick={handleNFCStats}
            style={{
              border: isNFCStatsActive
                ? "2px solid var(--primary_button_color)"
                : "2px solid var(--border_color)",
            }}
          >
            <div>
              <img src={nfcscannedIcon} alt="Icon" width="50px" height="50px" />
            </div>
            <div>
              <h6 className="counter">{statsData.totalTeamNfcStatCount}</h6>
              <h6 className="totalTite">Lifetime Taps</h6>
            </div>
          </div>

          <div
            className="statsBoxWrapper"
            onClick={handleQRCodeStats}
            style={{
              border: isQRCodeStatsActive
                ? "2px solid var(--primary_button_color)"
                : "2px solid var(--border_color)",
            }}
          >
            <div>
              <img src={qr} alt="Icon" width="50px" height="50px" />
            </div>
            <div>
              <h6 className="counter">{statsData.totalTeamQRStatCount}</h6>
              <h6 className="totalTite">Total Team QR Codes Scanned</h6>
            </div>
          </div>

          <div
            className="statsBoxWrapper"
            onClick={handleFunctionsStats}
            style={{
              border: isFunctionsStatsActive
                ? "2px solid var(--primary_button_color)"
                : "2px solid var(--border_color)",
            }}
          >
            <div>
              <img src={qrcodescanned} alt="Icon" width="50px" height="50px" />
            </div>
            <div>
              <h6 className="counter">{statsData.totalFunctionQRStatCount}</h6>
              <h6 className="totalTite">Lifetime QR Code Scans</h6>
            </div>
          </div>
        </div>

        {isNFCStatsActive ? (
          <StatsDetail data={statsData.totalTeamNfcStat} isNFC={true} />
        ) : null}
        {isQRCodeStatsActive ? (
          <StatsDetail data={statsData.totalTeamQRStat} isQRCode={true} />
        ) : null}
        {isFunctionsStatsActive ? (
          <StatsDetail data={statsData.totalFunctionQRStat} />
        ) : null}
      </div> */}
    </>
  );
};

export default Stats;
